const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_WORK_TYPES':
      return action.workTypes;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/workTypes.js